export const STATUS_TEXT_COLOR = 'var(--color-white)'

export const STATUS_QA_CONTEXT = 'chip'

export const STATUS_SIZE_24 = 24

export const STATUS_SIZE_20 = 20

export const STATUS_SIZE_16 = 16
